<template>
    <div class="container mx-auto h-screen flex items-center justify-center">
        <div class="md:w-full text-center">
            <span class="display-1 block">⏳</span>
            <div class="mb-4 lead">Se ha vencido tu sesión.</div>
            <div class="line-through">Redirigiendo al inicio de sesión...</div>
            <router-link
                to="/login"
                class="text-theme-primary underline cursor-pointer mt-3"
                aria-label="Ir a login"
            >
                Ir al login ahora 🔐
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "SessionExpired",
    mounted() {
        setTimeout(() => {
            this.$router.push("/login");
        }, 2000);
    }
};
</script>
